import { configureStore } from "@reduxjs/toolkit";
import jobReducer from "./jobSlice";
import countryReducer from "./countrySlice";
import skillReducer from "./skillsSlice";
import industrytypeReducer from "./industryTypeSlice";
import professionsReducer from "./professionsSlice";
import tagsReducer from "./tagsSlice";
import benefitsReducer from "./benefitsSlice";
import languageReducer from "./languagesSlice";
import companyReducer from "./companySlice";
import candidateReducer from "./candidateSlice";
import pricePlanReducer from "./priceplanSlice";

export const store = configureStore({
  reducer: {
    job: jobReducer,
    country: countryReducer,
    skill: skillReducer,
    industry_type: industrytypeReducer,
    profession: professionsReducer,
    tags: tagsReducer,
    benefits: benefitsReducer,
    language: languageReducer,
    company: companyReducer,
    candidate: candidateReducer,
    priceplan: pricePlanReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
